module.exports = __webpack_public_path__ + "img/20220423_162431.3a477593.jpg";